<template>
<svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <path :fill="color" d="M37.88,80.7c-1.56,0-2.88-.54-3.96-1.62-1.08-1.08-1.61-2.4-1.61-3.96s.54-2.88,1.62-3.96c1.08-1.08,2.4-1.61,3.96-1.61s2.88.54,3.96,1.62c1.08,1.08,1.62,2.4,1.62,3.96,0,1.56-.54,2.88-1.62,3.96-1.08,1.08-2.4,1.62-3.96,1.62ZM68.82,80.7c-1.56,0-2.88-.54-3.96-1.62-1.08-1.08-1.62-2.4-1.62-3.96s.54-2.88,1.62-3.96c1.08-1.08,2.4-1.61,3.96-1.61s2.88.54,3.96,1.62c1.08,1.08,1.61,2.4,1.61,3.96,0,1.56-.54,2.88-1.62,3.96-1.08,1.08-2.4,1.62-3.96,1.62ZM34.55,30.61l7.96,16.63h21.02c.36,0,.68-.09.95-.27.28-.18.52-.43.72-.74l7.64-13.95c.24-.44.26-.82.06-1.16-.2-.34-.54-.51-1.01-.51,0,0-37.34,0-37.34,0ZM32.1,25.49h44.53c1.32,0,2.32.55,2.98,1.65.67,1.1.67,2.23.01,3.39l-10.41,18.77c-.5.91-1.2,1.64-2.09,2.2-.9.56-1.88.84-2.95.84h-23.06l-2.84,5.05c-.32.48-.33.99-.03,1.55s.75.83,1.34.83h34.97v5.11h-36.67c-2.22,0-3.84-.94-4.86-2.83-1.02-1.89-1.03-3.75-.03-5.6l4.35-8-11.39-24.06h-6.07v-5.11h9.27l2.94,6.2ZM42.51,47.23h22.16-22.16Z"/>
</svg>
</template>

<script>
export default {
  name: 'ShopingCartIcon',
  props: {
    color: {
      type: String,
      default: '#fff'
    }
  }
}
</script>

<style>

</style>
